import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-months',
  templateUrl: './select-months.component.html',
  styleUrls: ['./select-months.component.scss']
})
export class SelectMonthsComponent implements  OnDestroy {

  public items: any[] = [
    { value: 12, name: 'Últ. 12 meses' },
    { value: 18, name: 'Últ. 18 meses' },
    { value: 24, name: 'Últ. 24 meses' },
    { value: 30, name: 'Últ. 30 meses' },
    { value: 36, name: 'Últ. 36 meses' },
    { value: 48, name: 'Últ. 48 meses' },
    { value: 60, name: 'Últ. 60 meses' }
  ];

  public monthsAgo: any = [];
  public ngxDisabled = false;
  monthsAgo$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.monthsAgo$ = this.sharedService.sharedMonthsAgo.subscribe(monthsAgo => {
      this.monthsAgo = monthsAgo;
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.monthsAgo$.unsubscribe();
  }

  changeMonthsAgo(event: any) {
    // ngx-select may return the value directly or in an array
    let value = event;
    if (Array.isArray(event) && event.length > 0) {
      value = event[0];
    }
    if (value && typeof value === 'object' && value.value !== undefined) {
      value = value.value;
    }
    
    this.monthsAgo = value;
    this.sharedService.nextMonthsAgo = this.monthsAgo;
  }

  isSelected(option: any): boolean {
    if (this.monthsAgo === null || 
        this.monthsAgo === undefined ||
        this.monthsAgo === '' ||
        (Array.isArray(this.monthsAgo) && this.monthsAgo.length === 0)) {
      return false;
    }
    
    let selectedValue: any;
    if (Array.isArray(this.monthsAgo)) {
      if (this.monthsAgo.length === 0) {
        return false;
      }
      selectedValue = this.monthsAgo[0];
      if (selectedValue && typeof selectedValue === 'object' && selectedValue.value !== undefined) {
        selectedValue = selectedValue.value;
      }
    } else {
      selectedValue = this.monthsAgo;
      if (selectedValue && typeof selectedValue === 'object' && selectedValue.value !== undefined) {
        selectedValue = selectedValue.value;
      }
    }
    
    // Handle mixed types (numbers, strings)
    return option.value === selectedValue;
  }
}
